export type ShareNetwork = "facebook" | "twitter" | "telegram" | "whatsapp";

// Стандартные share-эндпоинты сетей — референсный ShareIcons.js хранит их
// в href каждого элемента; собраны в одну функцию.
export const buildShareHref = (
  network: ShareNetwork,
  url: string,
  text: string
): string => {
  const u = encodeURIComponent(url);
  const s = encodeURIComponent(text);

  switch (network) {
    case "facebook":
      return `https://www.facebook.com/sharer/sharer.php?u=${u}`;
    case "twitter":
      return `https://twitter.com/intent/tweet?url=${u}&text=${s}`;
    case "telegram":
      return `https://t.me/share/url?url=${u}&text=${s}`;
    case "whatsapp":
      return `https://api.whatsapp.com/send?text=${s}%20${u}`;
  }
};
